export default "__VITE_ASSET__1voxMMFf__"